import React from "react";
import ArrowRightIcon from "../../../../assets/images/product/specmanager/arrow-right-s-line.svg";
import NotConfiguredIcon from "../../../../assets/images/product/specmanager/error-warning-fill.svg";
import ProductCountIcon from "../../../../assets/images/product/specmanager/stack-fill (1).svg";
import { SpecStatusChip } from "./specManagerUi";
import "./SpecList.css";

export default function SpecListRow({
  title,
  headerContent,
  subtitleBlock,
  status,
  productCount,
  metaContent,
  onClick,
}) {
  return (
    <button
      type="button"
      className="SpecList_Row"
      onClick={onClick}
    >
      <div className="SpecList_RowLeft">
        {headerContent != null ? headerContent : (
          <div className="SpecList_RowTitle" title={title}>
            {title}
          </div>
        )}
        {subtitleBlock && (
          <div className="SpecList_RowSubtitle">
            {subtitleBlock.showWarningIcon && (
              <img
                src={NotConfiguredIcon}
                alt=""
                className="SpecList_RowSubtitleIcon"
                aria-hidden
              />
            )}
            <span>{subtitleBlock.text}</span>
          </div>
        )}
        {metaContent}
      </div>
      <div className="SpecList_RowRight">
        {productCount > 0 && (
          <div className="SpecList_ProductCountBadge">
            <img
              src={ProductCountIcon}
              alt=""
              className="SpecList_ProductCountBadgeIcon"
              aria-hidden
            />
            <span>{productCount}</span>
          </div>
        )}
        <SpecStatusChip status={status} variant="list" />
        <img
          src={ArrowRightIcon}
          alt=""
          className="SpecList_RowChevron"
          aria-hidden
        />
      </div>
    </button>
  );
}
